import FullWidthLayout from "@/layouts/FullWidthLayout";
import KSchedulesTable from "kinnect-front/KYard/Schedule/KSchedulesTable";
import { FetchesData, Pageable } from "kinnect-mixins";
import { KTextField } from "kinnect-general";
import { VCard, VSheet } from "vuetify/lib";
import { YardSchedule } from "kinnect-models";

export default {
	name: "YardSchedulesRequestsPage",

	metaInfo: { title: "Yard - Schedule Requests" },

	mixins: [
		FetchesData,
		Pageable
	],

	data: () => ( {
		schedules: [],
		search: ""
	} ),

	computed: {
		numSchedules() {
			return this.schedules.length;
		}
	},

	watch: {
		numSchedules( numSchedules ) {
			this.$store.dispatch( "breadcrumbs/setDetails", `${numSchedules} requests` );
		}
	},

	methods: {
		async fetchSchedules() {
			this.schedules = await YardSchedule.custom( "yard/schedules/requests" ).get();
		},

		async fetch() {
			await this.fetchSchedules();
		}
	},

	render() {
		return <FullWidthLayout>
			<VCard>
				<VSheet class="pa-3" color="primary" tile>
					<KTextField
						clearable
						dark
						flat
						hideDetails
						label="Search"
						prependInnerIcon="search"
						soloInverted
						vModel={this.search}
					></KTextField>
				</VSheet>

				<KSchedulesTable
					dense
					items={this.schedules}
					loading={this.$wait.is( "get schedules" )}
					search={this.search}
					weather
				></KSchedulesTable>
			</VCard>
		</FullWidthLayout>;
	}
};
